import {EsquireClient} from "@/types/clients/esquire";

export default class LogOut {
    constructor(private client: EsquireClient) {
    }

    public async send(): Promise<boolean> {
        const response = await this.client.fetchAuthenticated(
            this.client.callcenterUrl({ path: "logout" }), {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                }
            }
        );

        if (!response.ok) return false;

        await response.json();
        return true;
    }
}
